import React from 'react';
import styled from 'styled-components';
import { returnItemsService } from '../../services/return-items-service/return-items-service';
import { ItemCard } from '../ItemCard';
import { mutations } from '../Items/hooks/utils';
import { hasMultiOrder } from '../AdditionalOrderForm/utils';
import { getOrderGroups } from '../Items/utils';
import { useMultiOrder } from '../Items/hooks/useMultiOrder';
import { ItemOrderGroup } from '../ItemOrderGroup';

const List = styled.ul`
  margin: 20px 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const SingleOrder = ({ returnItems }) =>
  returnItems.map((item) => (
    <li>
      <ItemCard item={item} readOnly borderless />
    </li>
  ));

const MultiOrder = ({ returnItems }) => {
  const { allOrders } = useMultiOrder();
  const groups = getOrderGroups({
    items: returnItems,
    orders: allOrders,
  });

  return Object.values(groups).map((group) => (
    <ItemOrderGroup group={group} borderless readOnly showCheckmark={false} headerDate={false} />
  ));
};

export const ReturnSummaryItems = () => {
  const isMultiOrder = hasMultiOrder({ returnItems: returnItemsService.getItems() });

  const returnItems = mutations({
    items: returnItemsService.getItems(),
    mutationConfigs: [{ type: 'quantity', key: 'return_qty' }],
  });

  return (
    <List className="returnSummary-module_return_item_list_">
      {isMultiOrder ? (
        <MultiOrder returnItems={returnItems} />
      ) : (
        <SingleOrder returnItems={returnItems} />
      )}
    </List>
  );
};
